// 通用Spinner组件
import { motion } from 'framer-motion';

interface SpinnerProps {
  size?: number;
  className?: string;
}

export const Spinner = ({ size = 16, className = '' }: SpinnerProps) => (
  <motion.svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    animate={{ rotate: 360 }}
    transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
    className={className}
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeDasharray="32 32"
      className="opacity-30"
    />
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeDasharray="20 44"
    />
  </motion.svg>
);

// 脉冲指示器
export const PulseIndicator = () => (
  <span className="relative flex h-2 w-2">
    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
    <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-500"></span>
  </span>
);

// 状态徽章
interface StatusBadgeProps {
  status: 'completed' | 'analyzing' | 'pending' | 'failed';
}

export const StatusBadge = ({ status }: StatusBadgeProps) => {
  const config = {
    completed: { color: 'bg-green-100 text-green-700', text: '已完成', icon: '✓' },
    analyzing: { color: 'bg-amber-100 text-amber-700', text: '分析中', icon: null },
    pending: { color: 'bg-gray-100 text-gray-600', text: '等待中', icon: '○' },
    failed: { color: 'bg-red-100 text-red-700', text: '失败', icon: '✕' }
  };

  const { color, text, icon } = config[status];

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${color}`}>
      {status === 'analyzing' ? <Spinner size={12} /> : <span>{icon}</span>}
      {text}
    </span>
  );
};
